import { render } from "./TodayConsumption.vue?vue&type=template&id=0f15c656&scoped=true&ts=true"
import script from "./TodayConsumption.vue?vue&type=script&lang=ts"
export * from "./TodayConsumption.vue?vue&type=script&lang=ts"

import "./TodayConsumption.vue?vue&type=style&index=0&id=0f15c656&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f15c656"]])

export default __exports__